import React, { Component } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import footerMenu from './footerMenu';

class Footer extends Component {
  render() {
    return (
      <div id="footer" className="footer">
        <div className="footer_menu">
          {footerMenu.map((menu) => (
            <dl key={menu.title}>
              <dt>{menu.title}</dt>

              {menu.subLink.map((sub) => (
                <dd key={sub.name}>
                  <Link href={sub.url}>
                    <a>{sub.name}</a>
                  </Link>
                </dd>
              ))}
            </dl>
          ))}
        </div>

        <div className="footer_images m-auto w-2/3 border-t border-white border-opacity-75">
          <div className="images w-2/3">
            <Image
              src={require('../../public/images/两排字.svg').default}
              alt="hidream讯梦国际"
            />

            <div className="qcode">
              <Image
                src={
                  require('../../public/images/Hidream-qcode@2x.png').default
                }
                alt="hidream-qcode"
              />
            </div>
            <p>关注Hidream公众号</p>
          </div>
        </div>

        <div className="address">
          <p>地址：浙江省杭州市萧山区皓月路159号<br/>诺德财富中心A座3301室</p>
        </div>

        <div className="copyright">
          <span className="icp-1">Hidream讯梦国际版权所有</span>
          <span className="icp-2">&nbsp;Copyright&nbsp;©&nbsp;2021</span>
          <span className="icp-3">
            <a
              target="_blank"
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010902003051"
              style={{ color: ' #96979e' }}
              rel="noreferrer"
            >
              <Image
                src={require('../../public/images/20211026162404.png').default}
                alt=""
                width={15}
                height={15}
              />
              浙公网安备&nbsp;33010902003051号
            </a>
          </span>
          <span className="icp-4">
            <a
              target="_blank"
              href="https://beian.miit.gov.cn/"
              style={{ color: ' #96979e' }}
              rel="noreferrer"
            >
              浙ICP备2021031902号
            </a>
          </span>
        </div>
      </div>
    );
  }
}

export default Footer;
